const normalizeProvider = (provider) => String(provider || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')

// Providers that are attribution/analytics sources, not native ad accounts a
// user can pick to view a report on. Add future analytics-only providers here.
const ANALYTICS_ONLY_PROVIDERS = new Set(['triplewhale', 'northbeam'])

// Filters out analytics-only accounts (e.g. TripleWhale) from a space's
// adAccounts list. Use this everywhere an ad-account selector or a
// default/auto-selected account is built from space.adAccounts, so an
// analytics-only account can never be shown as a choosable ad account or
// become the default chosen one. A no-op when the list has no such accounts.
export const getNativeAdAccounts = (adAccounts) => (
    (adAccounts || []).filter(account => !ANALYTICS_ONLY_PROVIDERS.has(normalizeProvider(account.provider)))
)
